// @ts-nocheck
/* eslint-disable */
import SceneControl from "./control";

export default class SceneControlContextMenu extends SceneControl {
	constructor(scene, itemId) {
		super(scene, itemId);

		this._items = [];
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneControlContextMenu",
			type: "control"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.items = this._items;

		return rd;
	}

	/**
	 * Pridani polozky do kontextoveho menu.
	 *
	 * @param {Object} item Polozka
	 */
	addItem(item) {
		this._items.push(item);

		this._onChange(this._scene.featureEvent("controlContextMenuAddItem", true, true), arguments);
	}

	/**
	 * Otevreni kontextoveho menu.
	 *
	 * @param  {Event} e
	 */
	open(e) {
		this._onChange(this._scene.featureEvent("controlContextMenuOpen", true, true), arguments);
	}

	/**
	 * Zavreni kontextoveho menu.
	 *
	 * @param  {Event} e
	 */
	close(e) {
		this._onChange(this._scene.featureEvent("controlContextMenuClose", true, true), arguments);
	}
}
